export const environment = {
  stage: false,
  production: true,
  resourcesUrl: '/api/Files/Get/',
  apiUrl:"/"
};
